import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { ApiConfig } from 'src/api.config';
import { FeedbackResponse } from './components/feedback-form/feedback-form.component';
import { of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MainService {
  private http = inject(HttpClient);


  getStatistics() {
    return this.http.get(`${ApiConfig.mainApiPublic}/irs-statistic`);
  }

  sendFeedback(data: FeedbackResponse, recaptcha: string) {
    return this.http.post(`${ApiConfig.mainApiPublic}/service-desk/send?g-recaptcha-response=${recaptcha}`, data);
  }
}
